import classNames from 'classnames';
import React from 'react';

import {GwgAccelerator} from '@udemy/career-academies';
import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {Button} from '@udemy/react-core-components';
import {QuestionsAndAnswers} from '@udemy/react-frequently-asked-questions';
import {ContentArea, ContentGrid, ContentGridItem} from '@udemy/react-layout-components';

import {InstructorStats} from 'src/components/grow-with-google/instructor-overview/instructor-overview.react-component';
import {ApiInstructor} from 'src/features/google-ai-path-page/types/course';

import styles from './gwg-footer.module.less';

export interface GwgFooterProps {
    instructor?: ApiInstructor;
    frequentlyAskedQuestions: GwgAccelerator['frequentlyAskedQuestions'];
}

export function GwgFooter({instructor, frequentlyAskedQuestions}: GwgFooterProps) {
    const {gettext} = useI18n();

    return (
        <div className={classNames('ud-full-viewport-container', styles['gwg-footer'])}>
            <ContentArea className="ud-container">
                <ContentGrid>
                    {instructor && (
                        <ContentGridItem
                            defaultSpan={12}
                            lgSpan={4}
                            className={styles['instructor-item']}
                        >
                            <h2
                                className={classNames(
                                    'ud-heading-xxl',
                                    styles['instructor-overview-title'],
                                )}
                            >
                                {gettext('Instructor overview')}
                            </h2>
                            <div className={styles['instructor-container']}>
                                <InstructorStats instructor={instructor} />
                            </div>
                        </ContentGridItem>
                    )}
                    <ContentGridItem
                        defaultSpan={12}
                        lgSpan={instructor ? 8 : 12}
                        className={styles['faq-item']}
                    >
                        <h2 className={classNames('ud-heading-xxl', styles['faq-title'])}>
                            {gettext('Frequently asked questions')}
                        </h2>
                        <div className={styles['faq-container']}>
                            <QuestionsAndAnswers
                                title={''}
                                numRowsToShow={5}
                                showMoreClass={styles['show-more-btn']}
                                showMoreStyle={'link'}
                                showMoreHasCount={true}
                                showButtonIcon={true}
                                questionsAndAnswers={frequentlyAskedQuestions || []}
                                darkVariant={true}
                            />
                        </div>
                    </ContentGridItem>
                </ContentGrid>
                <div className={styles['help-center']}>
                    <div className={styles['help-text']}>
                        <div className={styles['help-icon']}>
                            <Icon glyph="quiz" label={false} size="large" color="inherit" />
                        </div>
                        <div className={styles['help-text-content']}>
                            <span>{gettext('Looking for more info?')}</span>
                            <span>{gettext('Check out our help center for more support.')}</span>
                        </div>
                    </div>

                    <Button
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={gettext('Go to Help Center')}
                        componentClass="a"
                        href="https://support.udemy.com/hc/articles/37561451051415"
                        udStyle="secondary"
                        className={classNames('ud-text-md', styles['help-center-button'])}
                    >
                        {gettext('Go to Help Center')}
                        <Icon glyph="arrow-right" label={false} size="small" />
                    </Button>
                </div>
            </ContentArea>
        </div>
    );
}
